import React from 'react'

import style from './style.css'

export default props => (
    <div className={`${style.coverImage} ${(props.shadow) ? style['shadow'+props.shadow] : ''} ${props.className ? props.className : ''}`}
    style={{...props.style,
        backgroundImage: `url(${props.image})`
    }}>
        {/* <img className={style.image} src={props.image} alt={props.image} /> */}
        <div className={style.content}>
            {props.children}
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/ImageContent/index.js